import Store from '@/store';
import StatusPedidoClient from '@/api/status-pedido/status-pedido.client';
import { ErrorMessage } from '@/libs/Error';
import Notifier from '@/libs/Notifier';

export default class StatusPedidoService {
  constructor() {
    this.client = new StatusPedidoClient();
    this.error = new ErrorMessage();
    this.notify = new Notifier();
    this.store = Store;
  }

  async findAll(params = {}) {
    try {
      const response = await this.client.findAll(params);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar dados do relatório de status de pedidos');
      throw error;
    }
  }
}
